import React, { useState, useEffect } from 'react';
import { getPosts } from '../api/index';  // adjust the path if needed

const ViewPosts = () => {
  const [posts, setPosts] = useState([]);


  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await getPosts();
        setPosts(response.data);
      } catch (error) {
        console.error('Error fetching posts:', error);
      }
    };

    fetchPosts();
  }, []);

  return (
    <div className="Recent">
    <div className='Writings'>
    <div className='Writings-text'>
     <h1 id='Alpha'>RECENT</h1>
      {posts.map(post => (
        <div key={post.id} className='LinkAndSummary'>
            <h1 id='myh1'>{post.date}</h1>
            <p id='p1'> <a href={`/post/${post.title_short}`}>{post.title}</a> </p>
            <br></br>
            <p id='p1'>{post.description}</p>
            <p id="p2">
              {post.postPages.map( (page, index) => (
                <React.Fragment key={index}>
                <a href={'page/' + page}>{capitalizeFirstLetter(page)}</a>{'\t\t'}
                </React.Fragment>
              ))}
            </p>
            <br></br>
    
        </div>
      ))}
    </div>
    </div>
    </div>
  );
};

export default ViewPosts;
